import type { UTMParams } from "../types";

const UTM_KEYS: (keyof UTMParams)[] = ["source", "medium", "campaign", "term", "content"];

export function parseUTM(search: string): UTMParams {
  const params = new URLSearchParams(search);
  const result: UTMParams = { source: null, medium: null, campaign: null, term: null, content: null };
  for (const key of UTM_KEYS) {
    const v = params.get("utm_" + key);
    if (v) result[key] = v.slice(0, 256);
  }
  return result;
}

export function hostFromUrl(url: string | null | undefined): string | null {
  if (!url) return null;
  try {
    return new URL(url).hostname.toLowerCase();
  } catch {
    return null;
  }
}

export function classifyDeviceType(width: number): "mobile" | "tablet" | "desktop" {
  if (width < 768) return "mobile";
  if (width < 1024) return "tablet";
  return "desktop";
}

/**
 * Ad-network click ids. Yandex Direct auto-tagging adds `yclid` (no UTM at
 * all by default), Google Ads adds `gclid`/`gbraid`/`wbraid`, Meta `fbclid`,
 * Yandex search adds `ysclid` on organic clicks. Without this every such
 * visit lands in "direct" — on hellopark-avk.ru that was 54% of traffic.
 */
export function trafficFromClickIds(search: string): { source: string; medium: string } | null {
  const p = new URLSearchParams(search);
  if (p.has("yclid")) return { source: "yandex", medium: "cpc" };
  if (p.has("gclid") || p.has("gbraid") || p.has("wbraid")) return { source: "google", medium: "cpc" };
  if (p.has("fbclid")) return { source: "facebook", medium: "social" };
  if (p.has("ysclid")) return { source: "yandex", medium: "organic" };
  if (p.has("_openstat")) return { source: "openstat", medium: "cpc" };
  if (p.has("msclkid")) return { source: "bing", medium: "cpc" };
  return null;
}
